import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import Swal from 'sweetalert2';
import { ResultData } from '../_models/ResultData';
import { DataResponse } from '../_models/data/DataResponse';

@Injectable({
  providedIn: 'root'
})
export class DataUtilService {

  constructor(public authService:AuthService) { }
   getRandomInt(min, max) {
    min = Math.ceil(min);  // Round up to the nearest integer
    max = Math.floor(max); // Round down to the nearest integer
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  isGoodResponse(responseRs:any){
    let status=0
    let rx = JSON.parse(responseRs)
    if('rs' in rx){
      let rs=rx['rs']
      status=rs['status']
    }
     return status==1 ? true : false
  }

  isGoodObjectResponse(response:any){

    let rx = JSON.parse(response)
    let rs = rx['rs']
    let status =rs['status']
     return status==1 ? true : false
  }
  isGoodObjectResponseData(response:ResultData){

    let rs = response.rs
    let status =rs.status
     return status==1 ? true : false
  }
  myData(data:any){
    let rx = JSON.parse(data)
    let x= rx['rs']['data']
    return x
  }
  myDataRs(data:DataResponse){
    return data.rs.data
  }
  myDataData(response:ResultData){
    return response.rs.data
  }
  myObjectData(response:any){
    let rx = JSON.parse(response)
    let rs = rx['rs']
    return rs['data']
  }
  rawData(data:any){
    let rx = JSON.parse(data)

    return rx
  }
  trialAlertPendingMaxAlert(pendingQuizEnvelops:any,maxOpenSubjectQuiz:number,router:Router,isPremium:boolean,allQuizCount:number,maxOpenQuizNoAlert:number,subscriptionId){
    let n = pendingQuizEnvelops.length
    if(n >= maxOpenSubjectQuiz){
      var message ="Please first answer the  "+n+ " unanswered quiz!"
      Swal.fire( 'Oops',message,'info')
     }else if(!isPremium){
     if(allQuizCount > maxOpenQuizNoAlert){
       this.showOpenAlert()
     }else{
      router.navigate(['/student/quiz/guardian/show',subscriptionId])
     }
   }else{
    router.navigate(['/student/quiz/guardian/show',subscriptionId])
   }

  }

    showOpenAlert(){
      Swal.fire({
      title: '<strong>Free Trial Service</strong>',
      icon: 'info',
      html: 'Just to let you know that this is a Free Trial Service. Some topics will be crossed out. You can only create quiz for some of the topics. You need to upgrade to premium to enjoy unlimited access',
      showCloseButton: true,
      showCancelButton: true,
      allowOutsideClick: false,
      focusConfirm: true,
      confirmButtonText:'<i class="fa fa-thumbs-up"></i> Up grade to Premium',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText:'<i class="fa fa-thumbs-up"></i> Continue to Create Quiz',
      cancelButtonAriaLabel: 'Thumbs up'
    }).then((result) => {
      if (result.value) {

      }else if(result.dismiss === Swal.DismissReason.close){
        ;
      }else{

      }
  })

  }


}
